import { render } from "./FormSection2.vue?vue&type=template&id=2a8ce868&scoped=true"
import script from "./FormSection2.vue?vue&type=script&lang=js"
export * from "./FormSection2.vue?vue&type=script&lang=js"

import "./FormSection2.vue?vue&type=style&index=0&id=2a8ce868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8ce868"]])

export default __exports__